import React, { useRef, useEffect } from "react";
import DOMPurify from "dompurify";
import { Bold, Italic, Heading2, List, ListOrdered, Link2, Quote } from "lucide-react";

export function RichTextEditor({ value, onChange }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && value !== ref.current.innerHTML) {
      ref.current.innerHTML = DOMPurify.sanitize(value || "");
    }
    // eslint-disable-next-line
  }, []);

  const exec = (cmd, arg = null) => {
    document.execCommand(cmd, false, arg);
    ref.current?.focus();
    onChange(ref.current.innerHTML);
  };

  const addLink = () => {
    const url = window.prompt("Link URL");
    if (url) exec("createLink", url);
  };

  const Btn = ({ icon: Icon, onClick, label }) => (
    <button type="button" onClick={onClick} title={label} data-testid={`editor-${label}`}
      className="h-9 w-9 rounded-lg flex items-center justify-center text-[#4A534E] hover:bg-[#E3F3ED] hover:text-[#1A365D] transition-colors">
      <Icon className="h-4 w-4" />
    </button>
  );

  return (
    <div className="border border-[#E8E6DF] rounded-xl overflow-hidden bg-white">
      <div className="flex items-center gap-1 px-2 py-1.5 border-b border-[#E8E6DF] bg-[#FAFAF8] flex-wrap">
        <Btn icon={Bold} label="bold" onClick={() => exec("bold")} />
        <Btn icon={Italic} label="italic" onClick={() => exec("italic")} />
        <Btn icon={Heading2} label="heading" onClick={() => exec("formatBlock", "<h2>")} />
        <Btn icon={Quote} label="quote" onClick={() => exec("formatBlock", "<blockquote>")} />
        <Btn icon={List} label="bullets" onClick={() => exec("insertUnorderedList")} />
        <Btn icon={ListOrdered} label="numbered" onClick={() => exec("insertOrderedList")} />
        <Btn icon={Link2} label="link" onClick={addLink} />
      </div>
      <div
        ref={ref}
        contentEditable
        data-testid="editor-content"
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        className="prose-blog min-h-[260px] p-4 text-[#2A312D] focus:outline-none"
        suppressContentEditableWarning
      />
    </div>
  );
}
